import Actions from '../actions/actions';
import visitedUrlEventTriggersCRUDActions from '../actions/VisitedUrlEventTriggersCRUDActions';
import {
  VisitedUrlEventTrigger,
  VisitedUrlEventTriggerModel,
} from '../model/VisitedUrlEventTriggerModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entities: VisitedUrlEventTrigger[];
  entity: VisitedUrlEventTrigger;
};

const initialState: VisitedUrlEventTriggerModel = {
  busy: false,
  visitedUrlEventTriggers: [],
};

export const visitedUrlEventTriggers = (
  state = initialState,
  action: ActionType,
) => {
  switch (action.type) {
    case visitedUrlEventTriggersCRUDActions.busyAction:
      return setBusy(state);

    case visitedUrlEventTriggersCRUDActions.retrievedAllAction: {
      return {
        ...state,
        visitedUrlEventTriggers: action.entities,
        busy: false,
      };
    }
    case visitedUrlEventTriggersCRUDActions.deleteLocalAction: {
      const { id } = action.entity;
      const entities = state.visitedUrlEventTriggers.filter(c => c.id !== id);
      return {
        ...state,
        busy: false,
        visitedUrlEventTriggers: entities,
      };
    }
    case visitedUrlEventTriggersCRUDActions.retrievedAction: {
      const eventTrigger = action.entity;

      const { visitedUrlEventTriggers } = state;
      const index = visitedUrlEventTriggers.findIndex(
        p => p.id === eventTrigger.id,
      );
      const newVisitedUrlEventTriggers = Object.assign(
        [],
        visitedUrlEventTriggers.slice(),
        {
          [index === -1 ? visitedUrlEventTriggers.length : index]: eventTrigger,
        },
      );
      return {
        ...state,
        visitedUrlEventTriggers: newVisitedUrlEventTriggers,
        busy: false,
      };
    }
    case visitedUrlEventTriggersCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
